import { Injectable } from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {MatIconRegistry} from '@angular/material';

@Injectable()
export class CuiIconService {

  constructor(private iconRegistry: MatIconRegistry, private sanitizer: DomSanitizer) { }

  useIcons(iconNames: string[]): void {
    iconNames.forEach(iconName => {
      const url = this.sanitizer.bypassSecurityTrustResourceUrl(`assets/cui/${iconName}.svg`);

      this.iconRegistry.addSvgIcon(iconName, url);
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/icon/icon.service.ts